import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import { getActiveCustomer, getUserCustomers } from 'store/auth';
import { selectCustomerRequest, switchCustomerCancel } from 'store/customers';

import { BoxLink } from 'components/Common';
import { LoginLayout } from 'components';

// import IconNot from '../images/icon-not.svg';

export class SelectAccount extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    activeCustomer: PropTypes.object,
    customers: PropTypes.arrayOf(PropTypes.object).isRequired,
    onSelectCustomer: PropTypes.func.isRequired,
    onClickBack: PropTypes.func.isRequired
  };

  static defaultProps = {
    activeCustomer: null
  };

  constructor(props) {
    super(props);

    this.state = { selectedId: null };
  }

  handleClickCustomer = id => {
    if (this.state.selectedId === id) {
      return;
    }

    this.setState({ selectedId: id });

    this.props.onSelectCustomer(id);
  };

  handleClickBack = event => {
    event.preventDefault();

    this.props.onClickBack();
  };

  render() {
    return (
      <LoginLayout
        title={this.props.t('selectAccount.title')}
        description={this.props.t('selectAccount.description')}
        showSignUp={false}
      >
        <BoxLink.Container>
          {this.props.customers.map(customer => (
            <BoxLink
              key={customer.id}
              title={customer.name}
              description={customer.primaryAddress.streetAddress}
              isLoading={customer.id === this.state.selectedId}
              onClick={() => this.handleClickCustomer(customer.id)}
              to="/overview"
            />
          ))}

          {/* <BoxLink
            title={this.props.customers[0].name}
            description={this.props.customers[0].primaryAddress.streetAddress}
            icon={IconNot}
            inactive
            meta={this.props.t('selectAccount.item.inactive.meta')}
            to="/overview"
          /> */}
        </BoxLink.Container>

        {this.props.activeCustomer && (
          <Link onClick={this.handleClickBack} to="/overview">
            &larr; {this.props.t('general.back')}
          </Link>
        )}
      </LoginLayout>
    );
  }
}

const mapStateToProps = state => ({
  activeCustomer: getActiveCustomer(state),
  customers: getUserCustomers(state)
});

const mapDispatchToProps = {
  onSelectCustomer: selectCustomerRequest,
  onClickBack: switchCustomerCancel
};

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(SelectAccount)
);



// WEBPACK FOOTER //
// ./src/containers/SelectAccount/SelectAccount.js